import { BROADCAST_SET_SERVER_DELTA } from '../Types';

function setServerTimeDelta(delta) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_SERVER_DELTA,
      payload: delta
    };

    dispatch(action);
  };
}

export default setServerTimeDelta;
